//region block: pre-declaration
//endregion
function component1(_this__u8e3s4) {
  return _this__u8e3s4.animationsDisabled;
}
function component2(_this__u8e3s4) {
  return _this__u8e3s4.thirdPartyAvatarsDisabled;
}
function component3(_this__u8e3s4) {
  return _this__u8e3s4.config;
}
//region block: exports
export {
  component1 as component1202hq8a9nou0w,
  component2 as component22tb2ggnowdi2j,
  component3 as component33ssyybivzamim,
};
//endregion

//# sourceMappingURL=CouplingRouterPropsExtentions.mjs.map
